import crowdService from 'services/crowdService';
import {
  fetchCompetencyAssessmentRequest,
  fetchCompetencyAssessmentSuccess,
  fetchCompetencyAssessmentFailure,
  setCompetencyAccessBlocked,
} from './competency.action';

// Helper function to calculate overall percentage
const calculateOverallPercentage = (assessments: any[]): number => {
  if (!assessments || assessments.length === 0) return 0;
  
  let total = 0;
  assessments.forEach((each: any) => {
    total += each?.percentage || 0;
  });
  
  return Math.round(total / assessments.length);
};

// Thunk action to fetch competency assessment
export const fetchCompetencyAssessment = (userId: string, force: boolean = false) => async (dispatch: any, getState: any) => {
  if (!userId) return;

  // Prevent duplicate API calls - only fetch if not already loading or if forced
  const state = getState();
  const { loading, hasFetched } = state.competency || {};
  
  // Skip if already loading or if already fetched (unless forced)
  if (!force && (loading || hasFetched)) {
    console.log('⏭️ Skipping competency fetch - already loaded or loading', { loading, hasFetched });
    return;
  }

  console.log('✅ Proceeding with competency fetch', { userId, force });
  dispatch(fetchCompetencyAssessmentRequest());

  try {
    const res: any = await crowdService.fetchCompentencyAssessmentList(userId);

    if (!res.error) {
      const assessments = res?.data?.assessments || [];
      const percentage = calculateOverallPercentage(assessments);
      
      dispatch(fetchCompetencyAssessmentSuccess({
        assessments,
        pendingPercentage: percentage,
        isUserBlocked: res?.data?.is_user_blocked || false,
      }));

      // Set access blocked status if percentage is less than 100
      if (percentage < 100) {
        dispatch(setCompetencyAccessBlocked(res?.data?.is_user_blocked || false));
      } else {
        dispatch(setCompetencyAccessBlocked(false));
      }
    } else {
      dispatch(fetchCompetencyAssessmentFailure(res.error));
    }
  } catch (error) {
    dispatch(fetchCompetencyAssessmentFailure(error));
  }
};

